var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.292 6.307-.307-.328v1.242c0 .382.187.74.5.958l.41.286v-.639c0-.566-.214-1.106-.603-1.52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.098 5.55-1.573-1.675a.553.553 0 1 0-.806.757l1.266 1.347.307.328c.389.413.602.953.602 1.52v4.671a.613.613 0 0 1-1.224 0v-2.193a2.321 2.321 0 0 0-1.946-2.287V3.235a.816.816 0 0 0-.816-.816H5.72c.255.361.51.743.75 1.136h4.059v3.38H7.78a3.903 3.903 0 0 1-3.793 4.23v4.089h7.736V9.15c.487.158.84.616.84 1.155v2.193c0 .947.77 1.718 1.718 1.718A1.72 1.72 0 0 0 16 12.498V7.826c0-.849-.32-1.657-.902-2.277"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.899 10.334A3.147 3.147 0 0 1 .77 7.206c0-2.007 2.056-4.569 3.128-5.97C4.97 2.638 7.027 5.2 7.027 7.207a3.147 3.147 0 0 1-3.128 3.128M7.797 7.27c0-.11-.006-.222-.016-.334h2.748v-3.38h-4.06A20.73 20.73 0 0 0 5.72 2.42c-.396-.562-.79-1.075-1.122-1.507L4.414.673 3.9 0l-.516.673L3.2.912C2.003 2.468 0 5.073 0 7.269a3.903 3.903 0 0 0 3.899 3.9l.09-.003a3.902 3.902 0 0 0 3.808-3.897",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.899 1.237C2.827 2.637.77 5.199.77 7.207a3.147 3.147 0 0 0 3.128 3.127 3.147 3.147 0 0 0 3.128-3.128c0-2.007-2.056-4.569-3.128-5.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.6e7348be6accbe9b3a90c5f3e55842b4.svg";
export { ForwardRef as ReactComponent };